module.exports = __webpack_public_path__ + "static/media/footer-instagram.ba4a09d9.svg";